import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertUtil } from 'src/app/shared/utils/alert-dialog.util';
import { saveBlob } from 'src/app/shared/utils/file-download.util';
import { ZoneService } from 'src/app/services/modules/instant-rate-manager/zone.service';

@Component({
  selector: 'app-bulk-suburb-modal',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './bulk-suburb-modal.component.html',
  styleUrl: './bulk-suburb-modal.component.scss',
})
export class BulkSuburbModalComponent {
  public activeModal = inject(NgbActiveModal);
  private zoneService = inject(ZoneService);

  selectedFile: File | null = null;
  isDragOver = false;
  isLoading = false;
  isDownloadingTemplate = false;

  onFileSelect(event: any) {
    const file = event.target.files[0];
    this.handleFile(file);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.handleFile(file);
    }
  }

  private handleFile(file: File) {
    if (file && (file.type === 'text/csv' || file.name.endsWith('.csv'))) {
      this.selectedFile = file;
    } else {
      AlertUtil.error('Invalid file type. Please upload a CSV file.');
      this.selectedFile = null;
    }
  }

  removeFile() {
    this.selectedFile = null;
  }

  uploadFile() {
    if (this.selectedFile) {
      this.activeModal.close(this.selectedFile);
    }
  }

  downloadTemplate() {
    this.isDownloadingTemplate = true;
    this.zoneService.downloadZoneTemplate().subscribe({
      next: (csvText: string) => {
        saveBlob(
          new Blob(
            [
              csvText,
            ],
            { type: 'text/csv' },
          ),
          'suburb_upload_template.csv',
        );
        this.isDownloadingTemplate = false;
      },
      error: (err: any) => {
        AlertUtil.error('Failed to download template. Please try again later.');
        this.isDownloadingTemplate = false;
      },
    });
  }
}
